import { render, staticRenderFns } from "./CsSoundInput.vue?vue&type=template&id=3217c27a&scoped=true&lang=pug&"
import script from "./CsSoundInput.vue?vue&type=script&lang=js&"
export * from "./CsSoundInput.vue?vue&type=script&lang=js&"
import style0 from "./CsSoundInput.vue?vue&type=style&index=0&id=3217c27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217c27a",
  null
  
)

export default component.exports